/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "sr-Cyrl-BA": {
        "week": {
          "0": "ове недеље",
          "1": "наредне недеље",
          "future": {
            "one": "за {0} недељу",
            "few": "за {0} недеље",
            "other": "за {0} недеља"
          },
          "past": {
            "one": "пре {0} недеље",
            "few": "пре {0} недеље",
            "other": "пре {0} недеља"
          },
          "-1": "претходне недеље"
        }
      },
      "sr-Latn-BA": {
        "week": {
          "0": "ove nedelje",
          "1": "naredne nedelje",
          "future": {
            "one": "za {0} nedelju",
            "few": "za {0} nedelje",
            "other": "za {0} nedelja"
          },
          "past": {
            "one": "pre {0} nedelje",
            "few": "pre {0} nedelje",
            "other": "pre {0} nedelja"
          },
          "-1": "prethodne nedelje"
        }
      },
      "sr-Latn": {
        "year": {
          "0": "ove godine",
          "1": "sledeće godine",
          "future": {
            "one": "za {0} godinu",
            "few": "za {0} godine",
            "other": "za {0} godina"
          },
          "past": {
            "one": "pre {0} godine",
            "few": "pre {0} godine",
            "other": "pre {0} godina"
          },
          "-1": "prošle godine"
        },
        "year-short": {
          "0": "ove god.",
          "1": "sledeće god.",
          "future": {
            "one": "za {0} god.",
            "few": "za {0} god.",
            "other": "za {0} god."
          },
          "past": {
            "one": "pre {0} god.",
            "few": "pre {0} god.",
            "other": "pre {0} god."
          },
          "-1": "prošle god."
        },
        "year-narrow": {
          "0": "ove g.",
          "1": "sledeće g.",
          "future": {
            "one": "za {0} g.",
            "few": "za {0} g.",
            "other": "za {0} g."
          },
          "past": {
            "one": "pre {0} g.",
            "few": "pre {0} g.",
            "other": "pre {0} g."
          },
          "-1": "prošle g."
        },
        "quarter": {
          "0": "ovog kvartala",
          "1": "sledećeg kvartala",
          "future": {
            "one": "za {0} kvartal",
            "few": "za {0} kvartala",
            "other": "za {0} kvartala"
          },
          "past": {
            "one": "pre {0} kvartala",
            "few": "pre {0} kvartala",
            "other": "pre {0} kvartala"
          },
          "-1": "prošlog kvartala"
        },
        "quarter-short": {
          "0": "ovog kvartala",
          "1": "sledećeg kvartala",
          "future": {
            "one": "za {0} kv.",
            "few": "za {0} kv.",
            "other": "za {0} kv."
          },
          "past": {
            "one": "pre {0} kv.",
            "few": "pre {0} kv.",
            "other": "pre {0} kv."
          },
          "-1": "prošlog kvartala"
        },
        "quarter-narrow": {
          "0": "ovog kvartala",
          "1": "sledećeg kvartala",
          "future": {
            "one": "za {0} kv.",
            "few": "za {0} kv.",
            "other": "za {0} kv."
          },
          "past": {
            "one": "pre {0} kv.",
            "few": "pre {0} kv.",
            "other": "pre {0} kv."
          },
          "-1": "prošlog kvartala"
        },
        "month": {
          "0": "ovog meseca",
          "1": "sledećeg meseca",
          "future": {
            "one": "za {0} mesec",
            "few": "za {0} meseca",
            "other": "za {0} meseci"
          },
          "past": {
            "one": "pre {0} meseca",
            "few": "pre {0} meseca",
            "other": "pre {0} meseci"
          },
          "-1": "prošlog meseca"
        },
        "month-short": {
          "0": "ovog mes.",
          "1": "sledećeg mes.",
          "future": {
            "one": "za {0} mes.",
            "few": "za {0} mes.",
            "other": "za {0} mes."
          },
          "past": {
            "one": "pre {0} mes.",
            "few": "pre {0} mes.",
            "other": "pre {0} mes."
          },
          "-1": "prošlog mes."
        },
        "month-narrow": {
          "0": "ovog m.",
          "1": "sledećeg m.",
          "future": {
            "one": "za {0} m.",
            "few": "za {0} m.",
            "other": "za {0} m."
          },
          "past": {
            "one": "pre {0} m.",
            "few": "pre {0} m.",
            "other": "pre {0} m."
          },
          "-1": "prošlog m."
        },
        "week": {
          "0": "ove nedelje",
          "1": "sledeće nedelje",
          "future": {
            "one": "za {0} nedelju",
            "few": "za {0} nedelje",
            "other": "za {0} nedelja"
          },
          "past": {
            "one": "pre {0} nedelje",
            "few": "pre {0} nedelje",
            "other": "pre {0} nedelja"
          },
          "-1": "prošle nedelje"
        },
        "week-short": {
          "0": "ove ned.",
          "1": "sledeće ned.",
          "future": {
            "one": "za {0} ned.",
            "few": "za {0} ned.",
            "other": "za {0} ned."
          },
          "past": {
            "one": "pre {0} ned.",
            "few": "pre {0} ned.",
            "other": "pre {0} ned."
          },
          "-1": "prošle ned."
        },
        "week-narrow": {
          "0": "ove n.",
          "1": "sledeće n.",
          "future": {
            "one": "za {0} n.",
            "few": "za {0} n.",
            "other": "za {0} n."
          },
          "past": {
            "one": "pre {0} n.",
            "few": "pre {0} n.",
            "other": "pre {0} n."
          },
          "-1": "prošle n."
        },
        "day": {
          "0": "danas",
          "1": "sutra",
          "2": "prekosutra",
          "future": {
            "one": "za {0} dan",
            "few": "za {0} dana",
            "other": "za {0} dana"
          },
          "past": {
            "one": "pre {0} dana",
            "few": "pre {0} dana",
            "other": "pre {0} dana"
          },
          "-2": "prekjuče",
          "-1": "juče"
        },
        "day-short": {
          "0": "danas",
          "1": "sutra",
          "2": "prekosutra",
          "future": {
            "one": "za {0} d.",
            "few": "za {0} d.",
            "other": "za {0} d."
          },
          "past": {
            "one": "pre {0} d.",
            "few": "pre {0} d.",
            "other": "pre {0} d."
          },
          "-2": "prekjuče",
          "-1": "juče"
        },
        "day-narrow": {
          "0": "danas",
          "1": "sutra",
          "2": "prekosutra",
          "future": {
            "one": "za {0} d.",
            "few": "za {0} d.",
            "other": "za {0} d."
          },
          "past": {
            "one": "pre {0} d.",
            "few": "pre {0} d.",
            "other": "pre {0} d."
          },
          "-2": "prekjuče",
          "-1": "juče"
        },
        "hour": {
          "0": "ovog sata",
          "future": {
            "one": "za {0} sat",
            "few": "za {0} sata",
            "other": "za {0} sati"
          },
          "past": {
            "one": "pre {0} sata",
            "few": "pre {0} sata",
            "other": "pre {0} sati"
          }
        },
        "hour-short": {
          "0": "ovog sata",
          "future": {
            "one": "za {0} č.",
            "few": "za {0} č.",
            "other": "za {0} č."
          },
          "past": {
            "one": "pre {0} č.",
            "few": "pre {0} č.",
            "other": "pre {0} č."
          }
        },
        "hour-narrow": {
          "0": "ovog sata",
          "future": {
            "one": "za {0} č.",
            "few": "za {0} č.",
            "other": "za {0} č."
          },
          "past": {
            "one": "pre {0} č.",
            "few": "pre {0} č.",
            "other": "pre {0} č."
          }
        },
        "minute": {
          "0": "ovog minuta",
          "future": {
            "one": "za {0} minut",
            "few": "za {0} minuta",
            "other": "za {0} minuta"
          },
          "past": {
            "one": "pre {0} minuta",
            "few": "pre {0} minuta",
            "other": "pre {0} minuta"
          }
        },
        "minute-short": {
          "0": "ovog minuta",
          "future": {
            "one": "za {0} min.",
            "few": "za {0} min.",
            "other": "za {0} min."
          },
          "past": {
            "one": "pre {0} min.",
            "few": "pre {0} min.",
            "other": "pre {0} min."
          }
        },
        "minute-narrow": {
          "0": "ovog minuta",
          "future": {
            "one": "za {0} min.",
            "few": "za {0} min.",
            "other": "za {0} min."
          },
          "past": {
            "one": "pre {0} min.",
            "few": "pre {0} min.",
            "other": "pre {0} min."
          }
        },
        "second": {
          "0": "sada",
          "future": {
            "one": "za {0} sekundu",
            "few": "za {0} sekunde",
            "other": "za {0} sekundi"
          },
          "past": {
            "one": "pre {0} sekunde",
            "few": "pre {0} sekunde",
            "other": "pre {0} sekundi"
          }
        },
        "second-short": {
          "0": "sada",
          "future": {
            "one": "za {0} sek.",
            "few": "za {0} sek.",
            "other": "za {0} sek."
          },
          "past": {
            "one": "pre {0} sek.",
            "few": "pre {0} sek.",
            "other": "pre {0} sek."
          }
        },
        "second-narrow": {
          "0": "sada",
          "future": {
            "one": "za {0} s.",
            "few": "za {0} s.",
            "other": "za {0} s."
          },
          "past": {
            "one": "pre {0} s.",
            "few": "pre {0} s.",
            "other": "pre {0} s."
          }
        }
      },
      "sr": {
        "nu": ["latn"],
        "year": {
          "0": "ове године",
          "1": "следеће године",
          "future": {
            "one": "за {0} годину",
            "few": "за {0} године",
            "other": "за {0} година"
          },
          "past": {
            "one": "пре {0} године",
            "few": "пре {0} године",
            "other": "пре {0} година"
          },
          "-1": "прошле године"
        },
        "year-short": {
          "0": "ове год.",
          "1": "следеће год.",
          "future": {
            "one": "за {0} год.",
            "few": "за {0} год.",
            "other": "за {0} год."
          },
          "past": {
            "one": "пре {0} год.",
            "few": "пре {0} год.",
            "other": "пре {0} год."
          },
          "-1": "прошле год."
        },
        "year-narrow": {
          "0": "ове г.",
          "1": "следеће г.",
          "future": {
            "one": "за {0} г.",
            "few": "за {0} г.",
            "other": "за {0} г."
          },
          "past": {
            "one": "пре {0} г.",
            "few": "пре {0} г.",
            "other": "пре {0} г."
          },
          "-1": "прошле г."
        },
        "quarter": {
          "0": "овог квартала",
          "1": "следећег квартала",
          "future": {
            "one": "за {0} квартал",
            "few": "за {0} квартала",
            "other": "за {0} квартала"
          },
          "past": {
            "one": "пре {0} квартала",
            "few": "пре {0} квартала",
            "other": "пре {0} квартала"
          },
          "-1": "прошлог квартала"
        },
        "quarter-short": {
          "0": "овог квартала",
          "1": "следећег квартала",
          "future": {
            "one": "за {0} кв.",
            "few": "за {0} кв.",
            "other": "за {0} кв."
          },
          "past": {
            "one": "пре {0} кв.",
            "few": "пре {0} кв.",
            "other": "пре {0} кв."
          },
          "-1": "прошлог квартала"
        },
        "quarter-narrow": {
          "0": "овог квартала",
          "1": "следећег квартала",
          "future": {
            "one": "за {0} кв.",
            "few": "за {0} кв.",
            "other": "за {0} кв."
          },
          "past": {
            "one": "пре {0} кв.",
            "few": "пре {0} кв.",
            "other": "пре {0} кв."
          },
          "-1": "прошлог квартала"
        },
        "month": {
          "0": "овог месеца",
          "1": "следећег месеца",
          "future": {
            "one": "за {0} месец",
            "few": "за {0} месеца",
            "other": "за {0} месеци"
          },
          "past": {
            "one": "пре {0} месеца",
            "few": "пре {0} месеца",
            "other": "пре {0} месеци"
          },
          "-1": "прошлог месеца"
        },
        "month-short": {
          "0": "овог мес.",
          "1": "следећег мес.",
          "future": {
            "one": "за {0} мес.",
            "few": "за {0} мес.",
            "other": "за {0} мес."
          },
          "past": {
            "one": "пре {0} мес.",
            "few": "пре {0} мес.",
            "other": "пре {0} мес."
          },
          "-1": "прошлог мес."
        },
        "month-narrow": {
          "0": "овог м.",
          "1": "следећег м.",
          "future": {
            "one": "за {0} м.",
            "few": "за {0} м.",
            "other": "за {0} м."
          },
          "past": {
            "one": "пре {0} м.",
            "few": "пре {0} м.",
            "other": "пре {0} м."
          },
          "-1": "прошлог м."
        },
        "week": {
          "0": "ове недеље",
          "1": "следеће недеље",
          "future": {
            "one": "за {0} недељу",
            "few": "за {0} недеље",
            "other": "за {0} недеља"
          },
          "past": {
            "one": "пре {0} недеље",
            "few": "пре {0} недеље",
            "other": "пре {0} недеља"
          },
          "-1": "прошле недеље"
        },
        "week-short": {
          "0": "ове нед.",
          "1": "следеће нед.",
          "future": {
            "one": "за {0} нед.",
            "few": "за {0} нед.",
            "other": "за {0} нед."
          },
          "past": {
            "one": "пре {0} нед.",
            "few": "пре {0} нед.",
            "other": "пре {0} нед."
          },
          "-1": "прошле нед."
        },
        "week-narrow": {
          "0": "ове н.",
          "1": "следеће н.",
          "future": {
            "one": "за {0} н.",
            "few": "за {0} н.",
            "other": "за {0} н."
          },
          "past": {
            "one": "пре {0} н.",
            "few": "пре {0} н.",
            "other": "пре {0} н."
          },
          "-1": "прошле н."
        },
        "day": {
          "0": "данас",
          "1": "сутра",
          "2": "прекосутра",
          "future": {
            "one": "за {0} дан",
            "few": "за {0} дана",
            "other": "за {0} дана"
          },
          "past": {
            "one": "пре {0} дана",
            "few": "пре {0} дана",
            "other": "пре {0} дана"
          },
          "-2": "прекјуче",
          "-1": "јуче"
        },
        "day-short": {
          "0": "данас",
          "1": "сутра",
          "2": "прекосутра",
          "future": {
            "one": "за {0} д.",
            "few": "за {0} д.",
            "other": "за {0} д."
          },
          "past": {
            "one": "пре {0} д.",
            "few": "пре {0} д.",
            "other": "пре {0} д."
          },
          "-2": "прекјуче",
          "-1": "јуче"
        },
        "day-narrow": {
          "0": "данас",
          "1": "сутра",
          "2": "прекосутра",
          "future": {
            "one": "за {0} д.",
            "few": "за {0} д.",
            "other": "за {0} д."
          },
          "past": {
            "one": "пре {0} д.",
            "few": "пре {0} д.",
            "other": "пре {0} д."
          },
          "-2": "прекјуче",
          "-1": "јуче"
        },
        "hour": {
          "0": "овог сата",
          "future": {
            "one": "за {0} сат",
            "few": "за {0} сата",
            "other": "за {0} сати"
          },
          "past": {
            "one": "пре {0} сата",
            "few": "пре {0} сата",
            "other": "пре {0} сати"
          }
        },
        "hour-short": {
          "0": "овог сата",
          "future": {
            "one": "за {0} ч.",
            "few": "за {0} ч.",
            "other": "за {0} ч."
          },
          "past": {
            "one": "пре {0} ч.",
            "few": "пре {0} ч.",
            "other": "пре {0} ч."
          }
        },
        "hour-narrow": {
          "0": "овог сата",
          "future": {
            "one": "за {0} ч.",
            "few": "за {0} ч.",
            "other": "за {0} ч."
          },
          "past": {
            "one": "пре {0} ч.",
            "few": "пре {0} ч.",
            "other": "пре {0} ч."
          }
        },
        "minute": {
          "0": "овог минута",
          "future": {
            "one": "за {0} минут",
            "few": "за {0} минута",
            "other": "за {0} минута"
          },
          "past": {
            "one": "пре {0} минута",
            "few": "пре {0} минута",
            "other": "пре {0} минута"
          }
        },
        "minute-short": {
          "0": "овог минута",
          "future": {
            "one": "за {0} мин.",
            "few": "за {0} мин.",
            "other": "за {0} мин."
          },
          "past": {
            "one": "пре {0} мин.",
            "few": "пре {0} мин.",
            "other": "пре {0} мин."
          }
        },
        "minute-narrow": {
          "0": "овог минута",
          "future": {
            "one": "за {0} мин.",
            "few": "за {0} мин.",
            "other": "за {0} мин."
          },
          "past": {
            "one": "пре {0} мин.",
            "few": "пре {0} мин.",
            "other": "пре {0} мин."
          }
        },
        "second": {
          "0": "сада",
          "future": {
            "one": "за {0} секунду",
            "few": "за {0} секунде",
            "other": "за {0} секунди"
          },
          "past": {
            "one": "пре {0} секунде",
            "few": "пре {0} секунде",
            "other": "пре {0} секунди"
          }
        },
        "second-short": {
          "0": "сада",
          "future": {
            "one": "за {0} сек.",
            "few": "за {0} сек.",
            "other": "за {0} сек."
          },
          "past": {
            "one": "пре {0} сек.",
            "few": "пре {0} сек.",
            "other": "пре {0} сек."
          }
        },
        "second-narrow": {
          "0": "сада",
          "future": {
            "one": "за {0} с.",
            "few": "за {0} с.",
            "other": "за {0} с."
          },
          "past": {
            "one": "пре {0} с.",
            "few": "пре {0} с.",
            "other": "пре {0} с."
          }
        }
      }
    },
    "availableLocales": ["sr-Cyrl-BA", "sr-Cyrl-ME", "sr-Cyrl-XK", "sr-Cyrl", "sr-Latn-BA", "sr-Latn-ME", "sr-Latn-XK", "sr-Latn", "sr"],
    "aliases": {
      "sr-BA": "sr-Cyrl-BA",
      "sr-ME": "sr-Latn-ME",
      "sr-RS": "sr-Cyrl-RS",
      "sr-XK": "sr-Cyrl-XK"
    },
    "parentLocales": {}
  });
}